import clsx from "clsx";
import { Line } from "rc-progress";

function ProgressBar({
  currentlevel,
  nextlevel,
  currPoints,
  totalPoints,
  type,
  title,
  percentage,
  topLableClass,
  topLabelStyle,
  hideNextPoints,
  strokeColor,
  centerLabel,
}) {
  return (
    <div>
      <div className="flex items-center justify-between gap-4 my-1.5">
        <span
          className={"flex items-center gap-[0.3rem] text-sm text-[#FFFFFF]"}
        >
          {type === "streak" ? title : `${currPoints} pts`}
        </span>

        <span className="flex items-center justify-end text-xs ">
          <span
            className={clsx(
              "text-[#FFFFFF80] text-sm flex items-center gap-1",
              topLableClass,
            )}
            style={topLabelStyle}
          >
            {type === "streak"
              ? `${percentage}%`
              : hideNextPoints
                ? ""
                : `${totalPoints} pts`}
          </span>
        </span>
      </div>
      <div className="flex justify-center w-full items-center">
        <div className="w-full relative">
          <Line
            className="col-span-8 bg-blackhue-rmc_hue  rounded-2xl"
            percent={
              type ? (percentage / 100) * 100 : (currPoints / totalPoints) * 100
            }
            strokeWidth={3}
            strokeColor={strokeColor ?? "#ffd700"}
            trailColor="#1A1F33"
            steps={2}
            strokeLinecap="round"
            gapDegree={200}
            gapPosition="bottom"
          />
          {centerLabel && (
            <span className="absolute inset-0 flex items-center justify-center text-white text-[10px] font-medium">
              {centerLabel}
            </span>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between gap-4 my-1.5">
        <span className="flex items-center gap-[0.3rem] text-xs text-[#FFFFFF]">
          {(!type || type === "badge") && currentlevel}
        </span>

        <span className="flex items-center justify-end text-xs ">
          <span className="text-[#FFFFFF80] text-xs flex items-center gap-1">
            {(!type || type === "badge") && nextlevel}
          </span>
        </span>
      </div>
    </div>
  );
}

export default ProgressBar;
